import React from 'react';
import { ClaimContext, ClaimFileType } from '../types';
import { isClaimWithMissingTrackingData, isManualClaim } from '../claimsHelpers';
import { ImportFileState } from './useFileImport';
import FileImportMessage from './FileImportMessage';
import ClaimStepClosableMessage from './ClaimStepClosableMessage';
import Locale from '../../../Translate/Locale';
import { useOrderItemBannerMessage } from './hooks/useOrderItemBannerMessage';

export type InvoiceStepBannerMessagesProps = {
  importInvoiceState: ImportFileState;
  isFailedToExtractInvoice: boolean | undefined;
  claim: Pick<
    ClaimContext,
    | 'type'
    | 'isReturnShipment'
    | 'isMultiShipmentOrder'
    | 'outsideOfDeadlineReason'
    | 'trackingCode'
    | 'shipmentId'
    | 'submissionInfo'
    | 'entryPoint'
  >;
};

function InvoiceStepBannerMessages(props: InvoiceStepBannerMessagesProps) {
  const { importInvoiceState, isFailedToExtractInvoice, claim } = props;

  const isTrackingDataMissing = isClaimWithMissingTrackingData(claim) || isManualClaim(claim);
  const orderItemsInfoMessage = useOrderItemBannerMessage(claim);

  return (
    <>
      {isFailedToExtractInvoice && (
        <ClaimStepClosableMessage intent={'warning'}>
          <Locale>INVOICE_EXTRACTION_ERROR_TEXT</Locale>
        </ClaimStepClosableMessage>
      )}
      <FileImportMessage state={importInvoiceState} fileType={ClaimFileType.INVOICE_DOCUMENT} />
      {isTrackingDataMissing && !claim.outsideOfDeadlineReason && (
        <ClaimStepClosableMessage intent="success">
          <Locale>CLAIMS_WITHIN_DEADLINE_MESSAGE</Locale>
        </ClaimStepClosableMessage>
      )}
      {orderItemsInfoMessage && (
        <ClaimStepClosableMessage intent={'info'}>
          <Locale>{orderItemsInfoMessage}</Locale>
        </ClaimStepClosableMessage>
      )}
    </>
  );
}

export default InvoiceStepBannerMessages;
